/* eslint-disable no-restricted-globals */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState, useContext, useEffect } from 'react';
import Input from './common/Input';
import { Pencil, XSquare } from 'react-bootstrap-icons';
import { Link } from "react-router-dom";
import { Badge, Form } from 'react-bootstrap';
import { CoreContext } from '../context/core-context';
import { AuthContext } from '../context/auth-context';
import { useForm } from "react-hook-form";


const UpcomingEvents = () => {

    const coreContext = useContext(CoreContext);
    const authContext = useContext(AuthContext);
    const [title, setTitle] = useState('');
    const [message, setMessage] = useState('');


    const fetchClient = () => {
        coreContext.fetchSelfEvents(authContext.itemId);
    }

    const { register, handleSubmit, errors, setValue } = useForm({});

    useEffect(fetchClient, []);

    const populateClient = () => {
        setTitle(coreContext.client.event_title);
        setMessage(coreContext.client.event_message);
    }

    useEffect(populateClient, [coreContext.client]);

    const deleteEvent = (id) => {
        const r = confirm("Delete Event ?");
        if (r === true) {
            coreContext.deleteEvent(id, coreContext.client.id);
        } else {

        }


    }

    const renderEvents = () => {
        const events = coreContext.events;
        if (events)
            return events.map(event => <tr key={event.id}><td>{event.title}</td><td>{event.message}</td><td>{event.edate}<br />{event.etime}</td><td><Link className="btn btn-primary btn-sm" title='Edit Event' to={`/event/${event.id}`}><Pencil size="12" /></Link></td><td><button onClick={() => deleteEvent(event.id)} type="button" className="btn btn-danger btn-sm" title="Delete Event"> <XSquare size="12" /> </button></td></tr>)
    }



    const onEventSectionHandler = (data) => {
        coreContext.updateEventSection(data.title, data.message, authContext.itemId);

    }


    return (<div className='container-fluid'>
        <div className="card">
            <div className="card-title mx-auto"><h3><Badge variant="success">Upcoming Events Section</Badge></h3></div>
            <div className="card-body">
                <Form autoComplete='off' onSubmit={handleSubmit(onEventSectionHandler)} noValidate>
                    <Input label='Title' value={title} name='title' minLength={2} maxLength={155} required={false} register={register} errors={errors} elementType='textarea' placeholder='Enter Title' />

                    <Input label='Image Message' value={message} name='message' minLength={2} maxLength={2000} required={false} register={register} errors={errors} elementType='textarea' placeholder='Enter Message' />

                    <Input elementType='button' variant='primary' value="Update" /> &nbsp;&nbsp; {coreContext.renderLoader()} &nbsp;&nbsp;
                    <Input variant='danger' label={coreContext.message} elementType='label' />
                    &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; <Link to="/add-event">Add Event</Link>
                </Form>
            </div>
        </div>
        <div className="card">
            <div className="card-title mx-auto"><h3><Badge variant="success">Upcoming Events</Badge></h3></div>
            <div className="card-body">
                <table className="table table-bordered table-sm">
                    <thead>
                        <tr><th>Title</th><th>Message</th><th>Date / Time</th><th></th><th></th></tr>
                    </thead>
                    <tbody>
                        {renderEvents()}
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    )
}

export { UpcomingEvents }